<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-gears"></i><strong> Ingreso de procesos</strong>
                <div class="card-header-actions"></div>
              </div>
              <b-card-group deck>
                <b-card no-body header="Seleccione tipo proceso">
                  <b-list-group v-for="data in processtype" flush>
                    <b-list-group-item
                      href="#"
                      @click="
                        gotoFormTipoProceso(
                          data.process_option,
                          data.id,
                          data.name
                        )
                      "
                      >{{ data.name }}
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-card-group>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";

numeral.locale("es");

var d = new Date();

export default {
  name: "inicio",
  components: {},
  mounted() {
    this.getTipoProcesos();
  },
  data() {
    return {
      processtype: []
    };
  },
  computed: {},
  methods: {
    gotoFormTipoProceso(process_option, idtipoproceso, tipoprocesotexto) {
      this.$router.push("/proceso/" + process_option + "/" + idtipoproceso);
    },
    getTipoProcesos() {
      this.$axios
        .get("/api/v1/processtype/")
        .then((res) => {
          this.processtype = res.data.results;
        })
        .catch((error) => console.log(errors));
    }
  },
  beforeMount() {}
};
</script>
